/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  flight: 'flight',
  outbound: 'outbound',
  inbound: 'inbound',
  oneway: 'oneway',
  roundtrip: 'roundtrip',
  to: 'to',
  adult: 'adult',
  child: 'child',
  infant: 'infant'
}; export default Keys;